import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Headings } from "../../../atoms/Headings";
import ManageInvestment from "../../../molecules/ManageInvestment";
import { useLocation } from "react-router-dom";
import "./investments.scss";
import ManageDrawdown from "../../../molecules/ManageDrawdown";
import ManageFlexiAccess from "../../../molecules/ManageFlexiAccess";

const Investments = (props) => {
  const { investorId } = props.memberObj;
  const location = useLocation();
  const {
    memberships,
    investmentStrategy,
    investmentStrategyKey,
    drawdownData,
    flexiAccess,
    cmsFunds,
    flexiAcessObject,
    strategies,
    personInfo,
    memberObj,
    directFromManage,
    back,
  } = location.state || {};
  const drawdownAccount = props?.memberObj?.accountDetailsForSavings.find(
    (account) => account.active === true //eslint-disable-line
  );
  const investorAccountId = drawdownAccount ? drawdownAccount.accountId : null;

  return (
    <div className="eac-investmetns-parent">
      <Container fluid>
        <Row>
          <Col lg={12} md={12}>
            <div className="eac-heading">
              <Headings
                pageTitle={
                  investmentStrategy
                    ? "Explore & change investments"
                    : flexiAccess
                      ? "Explore & change drawdown investments"
                      : "Explore & change drawdown"
                }
                bigTitle={true}
              />
            </div>
          </Col>
        </Row>
        <Row>
          {investmentStrategy ? (
            <ManageInvestment
              memberships={memberships}
              investmentStrategy={investmentStrategy}
              investmentStrategyKey={investmentStrategyKey}
              investorId={investorId}
              personInfo={personInfo}
              memberObj={memberObj}
            />
          ) : flexiAccess ? (
            <ManageFlexiAccess
              CMSfunds={cmsFunds}
              flexiAcessObject={flexiAcessObject}
              strategies={strategies}
              directFromManage={directFromManage}
              personInfo={personInfo}
            />
          ) : (
            <ManageDrawdown
              drawdownData={drawdownData}
              strategies={strategies}
              investorId={investorId}
              personInfo={personInfo}
              memberObj={memberObj}
              directFromManage={directFromManage}
              investorAccountId={investorAccountId}
              back={back}
            />
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Investments;
